import { LedgerHoldState } from './response.types'

// Резерв без тела значит две противоположные вещи (CPAYMENT-1739): выплата ещё
// в работе (active) или выплата отменена (released) — подпись строки собирается
// из пары (kind, holdState), а не из одного kind.
export const HOLD_LABELS: Record<LedgerHoldState, string> = {
  none: '',
  active: 'Средства зарезервированы',
  released: 'Резерв снят',
}

// Нулевая сумма сама не отличает откат от операции без движения — строку
// помечает Ledger (reversed).
export const REVERSED_LABEL = 'Отменена'

export const DIRECTION_OPTIONS = [
  { value: 'in', label: 'Приход' },
  { value: 'out', label: 'Расход' },
]
